import { sailTypesMap, SunSailShapeType, SunSailType } from "@biz/definitions/SunSailDefinitions";

export class SST {
  static AM = [SunSailType.SolidayA, SunSailType.SolidayM] as const;
  static AMX = [SunSailType.SolidayA, SunSailType.SolidayM, SunSailType.SolidayX] as const;
  static AMCX = [SunSailType.SolidayA, SunSailType.SolidayM, SunSailType.SolidayC, SunSailType.SolidayX] as const;
  static AMOne = [SunSailType.SolidayA, SunSailType.SolidayM, SunSailType.SolidayOne] as const;
  static AMXOne = [SunSailType.SolidayA, SunSailType.SolidayM, SunSailType.SolidayX, SunSailType.SolidayOne] as const;
  static AMCXOne = [SunSailType.SolidayA, SunSailType.SolidayM, SunSailType.SolidayC, SunSailType.SolidayX, SunSailType.SolidayOne] as const;
  static XXs = [SunSailType.SolidayX, SunSailType.SolidayXS] as const;
  static CsTwin = [SunSailType.SolidayCS, SunSailType.SolidayTwin] as const
  static CsXs = [SunSailType.SolidayCS, SunSailType.SolidayXS] as const
  static CsXsTwin = [SunSailType.SolidayCS, SunSailType.SolidayXS, SunSailType.SolidayTwin] as const
  static SF = [SunSailType.Standard, SunSailType.Fixed] as const
  static CoSF = [SunSailType.Concept, SunSailType.Standard, SunSailType.Fixed] as const
  static Sandy = [SunSailType.SandyRect, SunSailType.SandyPoly] as const;

  static A = SunSailType.SolidayA;
  static M = SunSailType.SolidayM;
  static C = SunSailType.SolidayC;
  static Cs = SunSailType.SolidayCS;
  static X = SunSailType.SolidayX;
  static Xs = SunSailType.SolidayXS;
  static Twin = SunSailType.SolidayTwin;
  static One = SunSailType.SolidayOne;
  static Co = SunSailType.Concept;
  static F = SunSailType.Fixed;
  static S = SunSailType.Standard;
  static Flex = SunSailType.SolidayFlex

  static is(sst: SunSailType | undefined, first: SunSailType | readonly SunSailType[], ...types: (SunSailType | readonly SunSailType[])[]): boolean {
    if (sst === undefined)
      return false;
    for (const type of [first, ...types]) {
      if (Array.isArray(type)) {
        for (const t of type) {
          if (t === sst)
            return true;
        }
      } else if (type === sst)
        return true;
    }
    return false;
  }

  static isRaff(sunSailType: SunSailType): boolean {
    return !!sailTypesMap[sunSailType].isRaff;
  }

  static isSail(sunSailType: SunSailType): boolean {
    return !!sailTypesMap[sunSailType].isSail;
  }

  static isNet(sunSailType: SunSailType): boolean {
    return !!sailTypesMap[sunSailType].isNet;
  }

  static isSailOrRaff(sunSailType: SunSailType): boolean {
    const item = sailTypesMap[sunSailType]
    return !!item.isRaff || !!item.isSail;
  }

  static isCurtain(sunSailType: SunSailType): boolean {
    return sunSailType === SunSailType.Curtain;
  }

  static isLounge(sunSailType: SunSailType): boolean {
    return sunSailType === SunSailType.Lounge;
  }

  static isModelProduct(sunSailType: SunSailType): boolean {
    return sunSailType === SunSailType.ModelProduct;
  }

  static isStandardCollection(sunSailType: SunSailType): boolean {
    return sunSailType === SunSailType.StandardCollection;
  }

  static getSunSailShape(sunSailType: SunSailType, poleCount: number): SunSailShapeType | undefined {
    if (SST.is(sunSailType, SST.Sandy)) {
      return undefined;
    } else if (SST.is(sunSailType, SST.CoSF)) {
      switch (poleCount) {
        case 3: return "tri"
        case 4: return "quad"
        case 5: return "penta"
        case 6: return "hexa";
      }
    }
    switch (poleCount) {
      case 3: return "triA";
      case 4: return SST.is(sunSailType, SST.CsXsTwin) ? "quadA" : "triATri";
      case 5: return "quadATri";
      case 6: return "quadAQuad";
    }
    throw new Error("Shape not supported so far!");
  }
}